/* eslint-disable react-hooks/exhaustive-deps */
import { useAtom } from 'jotai';
import { useCallback } from 'react';

import store from 'src/store';
import { ModalType, ModalStateProps } from 'src/store/modal';

interface OpenModalProps<T> {
  type: ModalType;
  data: Omit<T, 'open' | 'onClose'>;
  onClose?: VoidFunction;
}

interface Props {
  openModal: <T>(props: OpenModalProps<T>) => void;
  modalState: ModalStateProps;
}

export const useModal = (): Readonly<Props> => {
  const [modalState, setModalState] = useAtom(store.modal.modalState);

  const openModal = useCallback(<T = any>({ type, data, onClose }: OpenModalProps<T>) => {
    setModalState((prevState) => ({
      ...prevState, // 최신 상태 참조
      open: true,
      type,
      data,
      // 모달별 onClose는 다음 모달로 이어지면 안 된다.
      // 예: 탈퇴 완료 모달은 onClose에서 로그인으로 이동하는데, 이후 소비기한 삭제 모달이
      // onClose 없이 열리면 이전 onClose가 재사용되어 취소만 눌러도 로그인 화면으로 튕길 수 있다.
      onClose: onClose ?? (() => {}),
    }));
  }, []); // 의존성 배열 비우기 (함수형 업데이트 사용)

  return { openModal, modalState };
};
